import React from 'react';

import styled from 'styled-components';

import { canViewActionCenter, isVendorShopAdmin } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import SidebarMenuActionCenter from './SidebarMenuActionCenter';
import SidebarMenuAdmin from './SidebarMenuAdmin';
import SidebarMenuAIFeatures from './SidebarMenuAIFeatures';
import SidebarMenuCustomCommunityViews from './SidebarMenuCustomCommunityViews';
import SidebarMenuDefaultCommunityViews from './SidebarMenuDefaultCommunityViews';
import SidebarMenuMysteryShopping from './SidebarMenuMysteryShopping';
import SidebarMenuOther from './SidebarMenuOther';
import SidebarMenuOverview from './SidebarMenuOverview';
import SidebarMenuProposals from './SidebarMenuProposals';
import SidebarMenuVendorShopAdmin from './SidebarMenuVendorShopAdmin';
import { useSidebarMenuLogic } from '../hooks';

const StyledMenu = styled.div`
  color: white;
  background: transparent;
  font-size: 12px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  user-select: none;
`;

const SidebarMenu = () => {
  const { selectedCommunity } = useAppSelector((state) => state.global);
  const { currentUser } = useAppSelector((state) => state.auth);
  const isAdminUser = Boolean(currentUser?.isSuperuser || currentUser?.isStaff);
  const showActionCenter = canViewActionCenter(currentUser);

  const {
    showOverview,
    showShopRequests,
    showProposals,
    showShopperContent,
    showOtherMenu,
    showAIRecommendations,
    showAICompetitiveIntelligence,
    showCommunitiesToWatch,
    showCustomViews,
  } = useSidebarMenuLogic();
  const vendorShopAdmin = currentUser && isVendorShopAdmin(currentUser);
  const showAIFeatures =
    (!!selectedCommunity && !showShopperContent) ||
    showAIRecommendations ||
    showAICompetitiveIntelligence ||
    showCommunitiesToWatch;

  return (
    <StyledMenu className="mini-scroll">
      {showAIFeatures && <SidebarMenuAIFeatures />}
      {showOverview && <SidebarMenuOverview />}
      {selectedCommunity && !showShopperContent && <SidebarMenuDefaultCommunityViews />}
      {showProposals && <SidebarMenuProposals />}
      {showCustomViews && <SidebarMenuCustomCommunityViews />}
      {(showOtherMenu || (currentUser && !isAdminUser)) && <SidebarMenuOther />}
      {showShopRequests && <SidebarMenuMysteryShopping />}
      {showActionCenter && <SidebarMenuActionCenter />}
      {vendorShopAdmin && <SidebarMenuVendorShopAdmin />}
      {isAdminUser && <SidebarMenuAdmin />}
    </StyledMenu>
  );
};

export default SidebarMenu;
